import { actions as loadingActions } from "../components/loading/index";
import { message, notification } from "antd";
import LogRocket from 'logrocket';
export const login = (formVal, history) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());
    const firebase = getFirebase();
    const firestore = getFirestore();
    var provider = new firebase.auth.GoogleAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        //checkForNewUser
        if (result.additionalUserInfo.isNewUser) {
          //NewUser -> CheckDatabase ->CreateUser
          checkAndCreateNewUser(firestore, result, firebase, dispatch, history);
        } else if (!result.additionalUserInfo.isNewUser) {
          //ExistingUser->Login

          firestore
            .doc(`students/${result.user.uid}`)
            .get()
            .then(function(doc) {
              if (doc.exists) {
                firestore
                  .doc(`students/${result.user.uid}`)
                  .set(
                    {
                      lastSignInTime: Date.now()
                    },
                    { merge: true }
                  )
                  .then(() => {
                    dispatch(loadingActions.hideLoading());
                    dispatch({
                      type: "LOGIN_SUCCESS",
                      payload: {
                        step:
                          doc.data().profileCurrentStep < 11
                            ? doc.data().profileCurrentStep + 1
                            : 11
                      }
                    });

                    LogRocket.identify(result.user.uid, {
                      name: doc.data().fullName,
                      email:  doc.data().email,
                    });

                    if (doc.data().profileCurrentStep === 11) {
                      message.success("Welcome back :)");
                    } else {
                      if (doc.data().role != "ADMIN") {
                        message.success(
                          "Welcome back :) Complete your profile to proceed."
                        );
                      } else {
                        message.success("Welcome back :)");
                      }
                    }
                  });
              } else {
                //UserLogginign in Twice and For SomeReason Doc not Exist in Database
                checkAndCreateNewUser(
                  firestore,
                  result,
                  firebase,
                  dispatch,
                  history
                );
              }
            })
            .catch(function(error) {
              //Database Query Failed
              dispatch(loadingActions.hideLoading());
              dispatch({ type: "LOGIN_ERROR", error });
              message.error("something went wrong. | Error Info : " + error);
            });
        } else {
          //All cases failed. Probabilty Low
          userLogout(firebase, dispatch, result, null);
          message.error(
            "something went wrong. Please contact Admin(admin@vedic.dev). Error Info : All Cases Failed"
          );
        }
      })
      .catch(function(error) {
        //LoginFailed Due to Error
        dispatch(loadingActions.hideLoading());
        message.error("something went wrong. | Error Info" + error);
      });
  };
};

export const logout = (formVal, history) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    dispatch(loadingActions.showLoading());
    const firebase = getFirebase();

    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch(loadingActions.hideLoading());
        dispatch({ type: "HOME_PAGE_UNLOADED" });
      })
      .catch(function(error) {
        dispatch(loadingActions.hideLoading());
        //
        dispatch({ type: "LOGIN_ERROR", error });
        dispatch({ type: "HOME_PAGE_UNLOADED" });
        message.error("something went wrong");
      });
  };
};
function checkAndCreateNewUser(firestore, result, firebase, dispatch, history) {
  firestore
    .doc(`users/${result.user.email}`)
    .get()
    .then(function(doc) {
      //if doc.exists->new user valid, get the role and create a new user
      if (doc.exists) {
        //TODO : CheckFor admin and Campus and ProfileCurrentStep=9 for admin

        firestore
          .doc(`students/${result.user.uid}`)
          .set(
            {
              displayName: result.user.displayName,
              email: result.user.email,
              photoURL: result.user.photoURL,
              UID: result.user.uid,
              emailVerified: result.user.emailVerified,
              signInType: "Google",
              rollnumber: doc.data().rollnumber || null,
              campus: doc.data().campus || "",
              role: doc.data().role,
              profileCurrentStep: -1,
              lastSignInTime: Date.now()
            },
            { merge: true }
          )
          .then(() => {
            LogRocket.identify(result.user.uid, {
              name: doc.data().fullName,
              email:  doc.data().email,
            });
            //CreatingUser SuccessFull
            dispatch(loadingActions.hideLoading());
            dispatch({ type: "LOGIN_SUCCESS", payload: { step: 0 } });
            message.success("Welcome. Please complete your profile");
          })
          .catch(function(error) {
            //CreatingUserFailedInDatabase
            userLogout(firebase, dispatch, result, null);
            message.error("something went wrong. | Error Info : " + error);
          });
      } else {
        //userNotValid ->SignOut and DisplayError
        userLogout(firebase, dispatch, result, "yes");
      }
    })
    .catch(function(error) {
      userLogout(firebase, dispatch, result, null);
      message.error("something went wrong. | Error Info : " + error);
    });
}

function userLogout(firebase, dispatch, result, error) {
  firebase
    .auth()
    .signOut()
    .then(() => {
      dispatch(loadingActions.hideLoading());
      dispatch({ type: "HOME_PAGE_UNLOADED" });
      if (error) {
        notification.error({
          message: "Not allowed :(",
          duration: 0,
          description: `Could not find user with email ${result.user.email} in database. Please check the email that you loggedin with. OR please fill this form with your issue - https://bit.ly/vedic-login-issue .`
        });
      }
    })
    .catch(function(error) {
      //UserLogOutFailed
      dispatch(loadingActions.hideLoading());
      dispatch({ type: "LOGIN_ERROR", error });
      dispatch({ type: "HOME_PAGE_UNLOADED" });
      message.error("something went wrong " + error);
    });
}
